<template>
  <div class="modal-lecard" v-show="opened">
    <div class="modal-lecard-content modal-rounded-scroll shadow-sm" :class="{overflow}">
      <div class="py-4 p-md-3 bg-white shadow-sm">
        <div :id="headerId" class="container text-center position-relative">
          <a href="javascript:" @click="voltar()" class="btn btn-outline-light btn-voltar-round position-absolute" style="left: 12px; top: -9px" aria-label="Voltar">
            <i class="fa fa-chevron-left text-dark"></i>
          </a>
          <div class="font-weight-bold">
            <div class="m-auto" style="max-width: 60%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden">{{title}}</div>
          </div>
        </div>
      </div>
      <div class="modal-content-slot">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Modal",
    props: ['title', 'overflow'],
    data() {
      return {
        opened: false,
        headerId: `header_${this.$helpers.ID()}`
      }
    },

    methods: {
      voltar() {
        this.$emit('voltar');
      },

      closeModal() {
        this.opened = false;
        document.body.classList.remove("modal-open");
        this.$emit('closeModal');
      },

      openModal() {
        document.body.classList.add("modal-open");
        this.opened = true;
      }
    },

    created() {
      this.$parent.$on('openModal', () => {
        document.body.classList.add("modal-open");
        this.opened = true;
      });

      this.$parent.$on('closeModal', () => {
        this.closeModal();
      });

      this.$parent.$on('scrollTop', () => {
        if (this.headerId) {
          document.getElementById(this.headerId).scrollIntoView();
        }
      });
    },
  }
</script>

<style scoped>
  .modal-lecard {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  .modal-lecard-content {
    background-color: #fefefe;
    margin: 48px auto;
    width: 600px;
    height: 80vh;
    position: relative;
    border-radius: 12px;
    overflow: hidden;
  }

  .modal-lecard-content.overflow {
    overflow: auto;
  }

  @media (max-width: 767px) {
    .modal-lecard-content {
      overflow: auto;
      min-height: 100%;
      height: 100vh;
      width: 100%;
      margin: 0;
      border-radius: 0;
      clip-path: none;
    }
  }
</style>
